import React, { useEffect, useState } from 'react';
import { api, apiError } from '../../lib/api';

const STATUS = ['new','in_progress','converted','closed'];

export default function EmployeeEnquiries() {
  const [enqs, setEnqs] = useState([]);
  const [err, setErr] = useState('');

  const load = async () => { try { const {data} = await api.get('/employee/enquiries'); setEnqs(data.enquiries||[]); } catch(e){ setErr(apiError(e)); } };
  useEffect(() => { load(); }, []);

  const upd = async (e_, patch) => { await api.put(`/employee/enquiries/${e_.id}`, patch); await load(); };

  return (
    <div data-testid="employee-enquiries">
      <h2 className="mb-3">Enquiries assigned to me</h2>
      {err && <div className="alert alert-danger">{err}</div>}
      <div className="row g-3">
        {enqs.map(e => (
          <div className="col-md-6" key={e.id}>
            <div className="ap-card" data-testid={`emp-enq-${e.id}`}>
              <div className="d-flex justify-content-between">
                <div>
                  <div className="fw-bold">{e.customer_name}</div>
                  <div className="small text-muted-2">{e.business_name} · {e.source}</div>
                </div>
                <span className={'pill pill-'+e.status}>{e.status}</span>
              </div>
              <p className="mt-2">{e.message}</p>
              <div className="d-flex gap-2 flex-wrap">
                <select className="form-select form-select-sm" style={{maxWidth:180}} value={e.status} onChange={ev=>upd(e, { status: ev.target.value })} data-testid={`emp-enq-status-${e.id}`}>
                  {STATUS.map(s=> <option key={s} value={s}>{s}</option>)}
                </select>
                <input className="form-control form-control-sm" type="datetime-local" value={(e.follow_up_at||'').replace(' ','T').slice(0,16)} onChange={ev=>upd(e, { follow_up_at: ev.target.value.replace('T',' ')+':00' })} data-testid={`emp-enq-follow-${e.id}`} />
                <input className="form-control form-control-sm" placeholder="Follow-up notes" defaultValue={e.follow_up_notes||''} onBlur={ev=>upd(e, { follow_up_notes: ev.target.value })} data-testid={`emp-enq-notes-${e.id}`} />
              </div>
            </div>
          </div>
        ))}
        {enqs.length === 0 && <div className="ap-card">No enquiries assigned.</div>}
      </div>
    </div>
  );
}
